<app-top-nav [pageActions]="navActions"></app-top-nav>

<div class="main">
  <div class="wrapper">
    <div class="global-head-column">
      <div class="global-head-row">
        <div class="area-selector">
          <app-area-selector
            class="vertical-flex"
            (blockUpdated)="onUpdateAreaId($event)"
          ></app-area-selector>
        </div>

        <div class="handover-indicator" *ngIf="block && block?.handoverMode">
          <p>Hand Over Enabled</p>
        </div>
        <div class="search">
          <button
            class="empty-buildings"
            *ngIf="canOpenEmptyBuildingList()"
            [routerLink]="['/building-table/empty-buildings']"
            routerLinkActive="active"
            mat-stroked-button>
            Show Empty Buildings
          </button>
          <div class="searchBar">
            <input
              type="text"
              pInputText
              size="20"
              placeholder="Global Filter"
              [(ngModel)]="globalFilter"/>
            <button
              class="AZ-button"
              disabled
              mat-stroked-button
              color="secundary">
              <mat-icon class="searchIcon">search</mat-icon>
            </button>
        </div>
      </div>

      </div>
    </div>
    <div class="scroll-wrapper">
      <div class="no-area-id-wrapper" *ngIf="!block">
        <div class="message">
          <h5 i18n="@@buildinglist.table.header">
            Select a city, FH and Block to start.
          </h5>
        </div>
      </div>
      <p-table
        #dt
        [value]="tableData$() | async"
        [columns]="cols"
        selectionMode="single"
        id="table"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
        [virtualScroll]="false"
        class="table"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width: 4%">
              <p-checkbox
                #cbh
                binary="true"
                name="checked"
                [(ngModel)]="allRowsSelected"
                (click)="selectAllBuildings(cbh)"
              ></p-checkbox>
            </th>
            <th
              *ngFor="let col of columns"
              [class.col--type]="col.field == 'buildingType'"
              [class.col--suffix]="col.field == 'suffix'"
              [class.col--groupId]="
                col.field == 'buildingGroupId' ||
                col.field == 'buildingLomKey' ||
                col.field == 'addressLomKey'
              "
              [class.col--number]="col.field == 'number'"
              [class.col--mdu]="col.field == 'isMDU'"
              [class.col--date]="col.field == 'outsideStartTime'"
              [class.col--engineer]="col.field == 'outsideEngineer.firstName'"
              [class.status-cell]="col.field == 'surveyStatus'"
              [class.street-cell]="col.field == 'street'"
              [class.hidden]="col.hidden"
            >
              <div class="status-flex">
                <div
                  class="horizontal-flex"
                  *ngIf="!checkSortIcon(col.field); else filterHeader"
                >
                  {{ col.header }}
                </div>
                <ng-template #filterHeader>
                  <div
                    class="horizontal-flex clickable"
                    [matMenuTriggerFor]="extendedFilter"
                    #menuTrigger="matMenuTrigger"
                  >
                    {{ col.header }}
                    <ng-container
                      *ngIf="{
                        direction: (getFieldSort$(col.field) | async)
                      } as sort"
                    >
                      <mat-icon
                        class="sortIcon {{
                          sort.direction == 1
                            ? 'sort-ascending'
                            : 'sort-descending'
                        }}"
                        *ngIf="sort.direction"
                        >straight</mat-icon
                      >
                    </ng-container>
                    <mat-icon class="material-icons-outlined sortIcon"
                      >filter_alt</mat-icon
                    >
                    <ng-container
                      *ngIf="getFieldFilters$(col.field) | async as filters"
                    >
                      <span *ngIf="filters" class="clear-header-filters"
                        >({{ filters.length }})</span
                      >
                    </ng-container>
                  </div>
                  <mat-menu
                    class="column-filter-menu"
                    #extendedFilter="matMenu"
                    [hasBackdrop]="true"
                  >
                    <app-column-filter
                      *ngIf="menuTrigger.menuOpen"
                      [values]="getFieldValues$(col.field) | async"
                      [template]="getFieldTemplate(col.field)"
                      [canSearch]="getFieldFilterSearch(col.field)"
                      [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                      [initialSelected]="getFieldFilters$(col.field) | async"
                      [initialSort]="getFieldSort$(col.field) | async"
                      [ignoredValues]="col.ignoredFilterValues"
                      (sort)="setSort(col.field, $event)"
                      (filter)="setFilter(col.field, $event)"
                      (closePopup)="menuTrigger.closeMenu()"
                    ></app-column-filter>
                  </mat-menu>
                </ng-template>
                <ng-container *ngIf="col.field == 'surveyStatus'">
                  <button
                    class="clear-button"
                    mat-flat-button
                    color="warn"
                    (click)="clearAllFilter()"
                    *ngIf="extendedFilterActive$ | async"
                  >
                    clear all
                  </button>
                </ng-container>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-table let-i="rowIndex">
          <tr [ngClass]="{ 'p-highlight': isHighlight(i) }" class="p-row">
            <td style="width: 3%">
              <p-checkbox
                #cb
                [(ngModel)]="table.isChecked"
                binary="true"
                name="checked"
                (click)="selectBuilding(table, cb)"
              ></p-checkbox>
            </td>
            <td class="col--groupId">
              <ng-container
                *ngTemplateOutlet="
                  buildingGroup;
                  context: { data: table.figure }
                "
              ></ng-container>
            </td>
            <td class="col--groupId" *ngIf="checkDataField('buildingLomKey')">
              {{ table.buildingLomKey || "" }}
            </td>
            <td class="col--groupId" *ngIf="checkDataField('addressLomKey')">
              <!-- addressLomKey -->
            </td>
            <td class="street-cell">{{ table.street || "" }}</td>
            <td class="col--number">{{ table.number || "" }}</td>
            <td class="col--suffix">{{ table.suffix || "" }}</td>
            <td class="col--date" *ngIf="checkDataField('outsideStartTime')">
              <!-- starttime -->
            </td>
            <td
              class="col--engineer"
              *ngIf="checkDataField('outsideEngineer.firstName')"
            >
              {{
                (table.outsideEngineer && table.outsideEngineer.firstName) || ""
              }}
            </td>
            <td class="col--type">
              {{ BuildingTypeEnum[table.buildingType] || "" }}
            </td>
            <td class="col--mdu">
              <ng-container
                *ngTemplateOutlet="isMDU; context: { data: table?.isMDU }"
              ></ng-container>
            </td>
            <td class="status-cell" *ngIf="checkDataField('surveyStatus')">
              <app-survey-status
                [data]="displaySurveyStatus(table)"
                [allSurveys]="addressTable"
                (startSurvey)="onStartSurvey($event, i)"
                (goToSurvey)="onGoToSurvey($event, i)"
              ></app-survey-status>
            </td>
          </tr>
          <ng-container *ngIf="!table.isCollapsed">
            <tr
              class="address-row"
              *ngFor="let row of addressTable | BuildingId: table.buildingId"
            >
              <td style="width: 3%">
                <!-- checkbox -->
              </td>
              <td class="col--groupId">
                <!-- buildingGroupId -->
              </td>
              <td *ngIf="checkDataField('buildingLomKey')" class="col--groupId">
                <!-- buildingKey -->
              </td>
              <td *ngIf="checkDataField('addressLomKey')" class="col--groupId">
                {{ row.addressLomKey || "" }}
              </td>
              <td class="street-cell">{{ row.street || "" }}</td>
              <td class="col--number">{{ row.number || "" }}</td>
              <td class="col--suffix">{{ row.suffix || "" }}</td>
              <td class="col--date" *ngIf="checkDataField('outsideStartTime')">
                {{ (row.outsideStartTime | date) || "" }}
              </td>
              <td
                class="col--engineer"
                *ngIf="checkDataField('outsideEngineer.firstName')"
              >
                <!-- engineer -->
              </td>
              <td class="col--type">
                {{ AddressTypeEnum[row.addressType] || "" }}
              </td>
              <td class="col--mdu">
                <ng-container
                  *ngTemplateOutlet="isMDU; context: { data: row?.isMDU }"
                ></ng-container>
              </td>
              <td class="status-cell">
                <div class="content" *ngIf="addressActionsAvailble(row, table, addressTable)">
                  <a [matMenuTriggerFor]="actionMenu" class="dropdown">
                    <mat-icon>more_vert</mat-icon>
                  </a>
                  <mat-menu #actionMenu="matMenu" class="action-dropdown">
                    <div>
                      <h6
                        class="dropdown-header"
                        i18n="@@buildinglist.table.title.actions"
                      >
                        actions
                      </h6>
                      <a
                        *ngIf="addressReassignable(row.buildingId)"
                        class="dropdown-item delete-action"
                        (click)="reassignAddress(row)"
                      >
                        <mat-icon class="material-icons-outlined">
                          assignment_ind
                        </mat-icon>
                        <span
                          i18n="@@buildinglist.table.action.reassignaddress"
                        >
                          reassign address
                        </span>
                      </a>
                      <a
                        *ngIf="canAssingSurveyToMe(row)"
                        class="dropdown-item assign"
                        (click)="assignSurveyToMe(row, i)"
                      >
                        <mat-icon>person_outline</mat-icon>
                        <span i18n="@@buildinglist.table.action.assigntome">
                          assign survey to me
                        </span>
                      </a>
                      <a
                        *ngIf="surveyorReassignable(row.surveyStatus)"
                        class="dropdown-item assign"
                        (click)="assignSurveyToSurveyor(row)"
                      >
                        <mat-icon class="material-icons-outlined">
                          assignment_turned_in
                        </mat-icon>
                        <span
                          i18n="@@buildinglist.table.action.assigntosurveyor"
                        >
                          assign survey to Surveyor
                        </span>
                      </a>
                      <a
                        *ngIf="canGoBackToOutsideOngoing(table)"
                        class="dropdown-item back-to-outside"
                        (click)="backToOutsideOngoing(row)"
                      >
                        <mat-icon>arrow_back</mat-icon>
                        <span i18n="@@buildinglist.table.action.backtooutside">
                          back to outside ongoing
                        </span>
                      </a>
                      <a
                        *ngIf="canPrefillOutsideSurvey(row)"
                        class="dropdown-item view-outside"
                        (click)="prefillOutsideSurvey(row, i)"
                      >
                        <mat-icon>login</mat-icon>
                        <span
                          i18n="
                            @@buildinglist.table.action.prefilloutsidesurvey"
                        >
                          prefill outside survey
                        </span>
                      </a>
                      <a
                        *ngIf="canOpenOutsideSurvey(row.surveyStatus)"
                        class="dropdown-item view-outside"
                        (click)="openOutsideSurvey(row)"
                      >
                        <mat-icon>login</mat-icon>
                        <span
                          i18n="@@buildinglist.table.action.openoutsidesurvey"
                        >
                          open outside survey
                        </span>
                      </a>
                      <a
                        *ngIf="addressDeletable(row, addressTable)"
                        class="dropdown-item delete-action"
                        (click)="deleteAddress(row, addressTable)"
                      >
                        <mat-icon>delete_outline</mat-icon>
                        <span i18n="@@buildinglist.table.action.deleteaddress">
                          delete address
                        </span>
                      </a>
                    </div>
                  </mat-menu>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<app-reassign-option
  *ngIf="showReassignAddress"
  (closeReassignOption)="closeReassignAddress($event)"
  (reloadBuildingList)="getBuildingListByAreaId()"
  [areaId]="block.id"
  [buildingSurveyVm]="selectedAddressToReassign"
  [allBuildingSurveyVms]="addressTable"
></app-reassign-option>
<app-reassign-survey-to-surveyor
  *ngIf="showReassignSurveyor"
  (closeReassign)="closeReassignSurveyor($event)"
  (reloadBuildingList)="getBuildingListByAreaId()"
  [buildingSurveyVm]="selectedAddressToReassign"
  [buildingSurveyVms]="addressTable"
  [users]="users"
></app-reassign-survey-to-surveyor>

<!-- TEMPLATES -->
<ng-template #surveyStatus let-data="data">
  <app-survey-status-button
    [status]="data"
    [abbreviate]="false"
  ></app-survey-status-button>
</ng-template>
<ng-template #isMDU let-data="data">
  <mat-icon *ngIf="data" class="material-icons-outlined">check_circle</mat-icon>
</ng-template>
<ng-template #buildingGroup let-data="data">
  <app-figure
    [Color]="data?.Color"
    [Figure]="data?.Figure"
    style="margin: 0 !important"
  ></app-figure>
</ng-template>
